import * as React from 'react';

import type { InlineMathData } from '@gitbook/doc-core';
import type { InlineProps } from '@gitbook/slate-react';
import { LoadingIndicator } from '@gitbook/spine-react';

import { VoidInlineWithPopover } from '../common';
import { MathEditPopover } from './MathEditPopover';
import MathTeXView from './MathTeXView';

/**
 * Renderer for an math inline node.
 */
export function InlineMath(props: InlineProps): React.ReactElement {
    const { node, editor } = props;
    const { formula } = node.data.toFrozenObject() as InlineMathData;

    return (
        <VoidInlineWithPopover
            {...props}
            renderSpan={() => (
                <React.Suspense fallback={<LoadingIndicator size="small" />}>
                    <MathTeXView formula={formula} inline />
                </React.Suspense>
            )}
            popover={<MathEditPopover editor={editor} node={node} />}
            hoverHighlighting="inline"
        />
    );
}
